import { MAX_4U_WIDTH, MAX_NARROW_WIDTH_PRINT } from '../data/constants';
import * as transform from './transform';
import * as element from '../util/element';

const MIN_ITEM_CHARS = 16;
const MAX_ITEM_CHARS = 32;
const MIN_CHARS_RATIO = MIN_ITEM_CHARS / MAX_4U_WIDTH;


export function preRender(data, options) {
  if (__MARKETWATCH__) {
    if (options.size === 'marketwatch-ZT') {
      return data;
    }
  }
  data.legend = {
    enabled: options.legend.enabled && options.type !== 'pie' &&
      options.size !== 'marketwatch-ZT',
    navigation: { enabled: false },
  };
  if (data.legend.enabled) {
    options.forceLegendTop = options.legend.layout === 'right' &&
      ((options.print && options.width <= MAX_NARROW_WIDTH_PRINT) ||
       (!options.print && options.width <= MAX_4U_WIDTH));
    data = styleLegend(data, options);
    data = positionLegend(data, options);
  }
  return data;
}

function positionLegend(data, options) {
  const LH = parseFloat(options.styles.normal.lineHeight);
  if (options.forceLegendTop) {
    options.legend.layout = 'top';
  }
  switch (options.legend.layout) {
    case 'top':
      data.legend.layout = 'horizontal';
      data.legend.align = 'left';
      data.legend.verticalAlign = 'top';
      if (options.print) {
        data.legend.margin = (options.type === 'bar') ? 8 : 4;
      }
      break;
    case 'bottom':
      data.legend.layout = 'horizontal';
      data.legend.verticalAlign = 'bottom';
      data.legend.align = 'left';
      if (options.print) {
        if (options.type === 'bar') {
          data.legend.margin = 4;
          data.chart.spacing[2] += 6;
        } else {
          data.chart.spacing[2] += -2;
        }
      }
      break;
    // case 'right':
    default:
      data.legend.layout = 'vertical';
      data.legend.align = 'right';
      data.legend.verticalAlign = 'middle';
      break;
  }
  return data;
}

function styleLegend(data, options) {
  const fontFamilyStyle = options.product === 'financialnews' ? options.styles.font.normal : options.styles.font.semibold;
  const fontFamilyWeight = options.product === 'financialnews' ? options.styles.weight.normal : options.styles.weight.semibold;
  let fontSizePrint = 7.5;
  if (__FINANCIALNEWS__) {
    if (options.product === 'financialnews') {
      fontSizePrint = options.print && options.sizes['print-fn'].columns <= 2 ? '7.75px' : '12px';
    }
  }
  const fontStyle = options.print ? {
    fontFamily: options.styles.font.normal,
    fontWeight: options.styles.weight.normal,
    fontSize: fontSizePrint
  } : {
    fontFamily: fontFamilyStyle,
    fontWeight: fontFamilyStyle
  }
  let styles = options.styles.get('normal', fontStyle);

  if (__WSJ__) {
    if (options.product === 'wsj') {
      styles = Object.assign({}, {
        fontSize: options.styles.legend.fontSize,
        fontWeight: options.styles.legend.fontWeight,
        lineHeight: options.styles.legend.lineHeight
      });
    }
  }

  data.legend.itemStyle = styles;

  if (options.legend.layout === 'right' && !options.forceLegendTop) {
    const width = options.width * 0.25 - 20;//data.legend.margin;
    data.legend.itemStyle.width = width;//`${width}px`;
    if (options.print) {
      data.legend.margin = 4;
    }
    data.legend.padding = 2;
  } else {
    data.legend.padding = options.print ? 0 : 2;
  }
  data.legend.itemDistance = options.print ? 6 : 12;
  data.legend.itemMarginBottom = options.print ? 4 : 6;

  // this doesnt do what you think it does.
  // for some reason this helps space the series name and the series symbol
  data.legend.symbolWidth = options.print ? 4 : 9;

  if (__WSJ__) {
    if (options.product === 'wsj') {
      data.legend.symbolWidth = options.print ? 4 : 7;
    }
  }

  data.legend.symbolHeight = options.print ? 6 : 12;
  data.legend.symbolRadius = 0;
  for (let i = 0; i < data.series.length; i++) {
    if ((data.series[i].name.length > 55 && options.width < 480) && options.legend.layout === 'top') {
      let splitLegendName = data.series[i].name.split(' ');
      splitLegendName.splice(4, 0, '<br />');
      data.series[i].name = splitLegendName.join(' ');
    }
    // if (data.series[i].name.length > 15 && options.legend.layout === 'right') {
    //   let splitLegendName = data.series[i].name.split(' ');
    //   splitLegendName.splice(4, 0, '<br />');
    //   data.series[i].name = splitLegendName.join(' ');
    // }
  }

  return data;
}


export function postRender(highchart, options) {
  if (highchart.legend.options.enabled) {
    positionLegendContainer(highchart, options);
    const items = highchart.container.querySelectorAll('.highcharts-legend-item');
    disableItems(highchart, options, items);
    formatItems(highchart, options, items);
    if (options.legend.layout === 'right') {
      positionRightAlignedItems(highchart, options, items);
    }
  }
}

// Resets the legend group Y as items will track data/item paths instead.
// Note that `null` in Highcharts is not the same as `0`.
function positionLegendContainer(highchart, options) {
  const el = highchart.container.querySelector('.highcharts-legend');
  const isBar = options.type === 'bar';
  let x = null;
  let y = null;
  if (options.legend.layout === 'top') {
    y = isBar ? 0 : 0;
  } else if (options.legend.layout === 'bottom') {
    // y = highchart.spacingBox.height + highchart.legend.itemHeight;
    // y = options.height - parseFloat(options.styles.normal.lineHeight) * 2;
  } else if (options.legend.layout === 'right') {
    y = isBar ? null : 0;
  }
  transform.write(el, 'translate', x, y);
}

// Disable clicks on legend items since the Highcharts behavior is not
// requested and also a bit strange.
function disableItems(highchart, options, items) {
  for (let i = 0; i < highchart.series.length; i++) {
    highchart.series[i].legendGroup.element.onmouseover = null;
    items[i].querySelector('text').style.cursor = 'default';
  }
}

// Takes the color in the block and applies it to the text.
function formatItems(highchart, options, items) {
  let x = 0;
  let initX = 0;
  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    // Draw the key with the correct dimensions:
    let rect = null;
    let path = null;

    if (rect = item.querySelector('rect')) {
      if (options.product !== 'marketwatch') {
        rect.setAttribute('width', options.print ? 4 : 9);
        rect.setAttribute('height', options.print ? 6 : 13);
        rect.setAttribute('x', 0);
        rect.setAttribute('y', options.print ? 9 : 5);
      }
      if (__FINANCIALNEWS__) {
        if (options.product === 'financialnews') {
          const circleX = Number(items[i].children[0].getAttribute('x'));
          const circleY = Number(items[i].children[0].getAttribute('y'));
          const circleRadius = options.print && options.sizes['print-fn'].columns <= 2 ? 5.5 : 5;
          const positionY = options.print && options.sizes['print-fn'].columns <= 2 ? 3 : 11;
          const positionX = options.print ? 0 : 7;
          const circle = highchart.renderer.circle(positionX, positionY , circleRadius).attr({
            fill: items[i].children[1].getAttribute('fill')
          });
          items[i].append(circle.element);
          if (options.print) {
            items[i].children[0].setAttribute('x', circleX + 10 );
          }
          rect.setAttribute('opacity', 0);
        }
      }

      if (__MARKETWATCH__) {
        if ((options.type === 'bar' || options.type === 'area' || options.type === 'column') && options.product === 'marketwatch') {
          rect.setAttribute('width', 13);
          rect.setAttribute('height', 13);
          rect.setAttribute('x', -3);
          rect.setAttribute('y', 5);
        }
      }
    } else if (path = item.querySelector('path')) {
      if (options.product !== 'marketwatch') {
        path.setAttribute('stroke-width', options.print ? 6 : 13);
        path.setAttribute('d', options.print ?
        'M 0 12 L 4 12' :
        'M 0 11 L 9 11');
      }

      if(__WSJ__){
        if (options.product === 'wsj') {
          path.setAttribute('stroke-width', options.styles.legend.rectHeight);
          path.setAttribute('d', `M 0 11 L ${options.styles.legend.rectWidth} 11`);
        }
      }

      if (__MARKETWATCH__) {
        if (options.type === 'line' && options.product === 'marketwatch') {
          path.setAttribute('stroke-width', 3);
          path.setAttribute('d', 'M 0 11 L 9 11');
        } else if (options.type !== 'line' && options.product === 'marketwatch') {
          path.setAttribute('stroke-width', options.print ? 6 : 13);
          path.setAttribute('d', options.print ?
          'M 0 12 L 4 12' :
          'M 0 11 L 9 11');
        }
      }
      if (__FINANCIALNEWS__) {
        if (options.product === 'financialnews') {
          const pathColor = items[i].children[1].getAttribute('fill');
          const circleX = Number(items[i].children[2].getAttribute('x'));
          const circleY = Number(items[i].children[2].getAttribute('y'));
          const circleRadius = options.print && options.sizes['print-fn'].columns <= 2 ? 5.5 : 5;
          const positionY = options.print && options.sizes['print-fn'].columns <= 2 ? 3 : 4;
          const positionX = options.print ? 10 : 8;
          let circle = highchart.renderer.circle(circleX - positionX, circleY - positionY, circleRadius).attr({
            fill: pathColor
          });
          items[i].append(circle.element);
          path.setAttribute('opacity', 0);
          if (options.print) {
            const translateVal = items[i].getAttribute('transform');
            const getLastVal = translateVal.split(',');
            items[i].setAttribute('transform', 'translate(10,' + getLastVal[1]);
          }
        }
      }


    }

    if (options.print) {
      const text = item.querySelector('text');
      text.setAttribute('x', 6);
    }

    // Space the items apart. TODO: Figure out how to make Highcharts do this!
    // if (options.legend.layout !== 'right') {
    //   const translate = transform.read(item, 'translate');
    //   if (i === 0) {
    //      initX = translate[0];
    //   }
    //   if (translate[0] <= initX) {
    //     x = 0;
    //   }
    //   transform.write(item, 'translate', translate[0] + x);
    //   x += options.print ? 6 : 12;
    // }
  }
}

function positionRightAlignedItems(highchart, options, items) {
  switch (options.type) {
    case 'area':
    case 'line':
      positionLineItems(highchart, items, options);
      break;
    case 'column':
      positionColumnItems(highchart, items, options);
      break;
    case 'bar':
      positionBarItems(highchart);
      break;
  }
}

function positionLineItems(highchart, items, options) {
  const itemY = getLineItemsY(highchart.container, items, options);
  const botY = highchart.plotTop + highchart.plotHeight;
  positionLegendItems(itemY, items, options, botY);
}

function positionColumnItems(highchart, items, options) {
  const itemY = getColumnItemsY(highchart.container, items, options);
  const botY = highchart.plotTop + highchart.plotHeight;
  positionLegendItems(itemY, items, options, botY);
}

// Necessary because Highcharts messes up "middle".
function positionBarItems(highchart) {
  var legendEl = highchart.container.querySelector('g.highcharts-legend');
  var translate = transform.read(legendEl, 'translate');
  var height = legendEl.getBoundingClientRect().height;
  var newY = highchart.plotTop + (highchart.plotHeight - height) / 2;
  transform.write(legendEl, 'translate', translate[0], newY);
}


// Positions the legend items to track data points but not overlap.
function positionLegendItems(itemY, items, options, botY) {
  const lineHeight = parseFloat(options.styles.lineHeight.normal);
  const midIndex = Math.min(itemY.length - 1, Math.round(itemY.length / 2));
  const margin = 8;//options.print ? 4 : 8;

  let y = itemY[0].y;
  // let y = itemY[midIndex].y;
  // for (let i = midIndex - 1; i >= 0; i--) {
  //   let h = items[itemY[i].index].getBoundingClientRect().height + margin;
  //   itemY[i].y = Math.min(itemY[i].y, y - h);
  //   y = itemY[i].y;
  // }
  // y = itemY[midIndex].y +
    // items[itemY[midIndex].index].getBoundingClientRect().height + margin;
  for (let i = 0; i < items.length; i++) {
    itemY[i].y = Math.max(itemY[i].y, y);
    y = itemY[i].y + items[itemY[i].index].getBoundingClientRect().height + margin;
  }

  // y = 0;
  // for (let i = 0; i < midIndex; i++) {
  //   itemY[i].y = Math.max(y, itemY[i].y);
  //   y = itemY[i].y + items[itemY[i].index].getBoundingClientRect().height + margin;
  // }

  // for (let i = midIndex; i < items.length; i++) {
  //   // let h = y + items[itemY[i - 1].index].getBoundingClientRect().height;// + margin;
  //   itemY[i].y = Math.max(itemY[i].y, y);
  //   y = itemY[i].y + items[itemY[i].index].getBoundingClientRect().height + margin;
  // }

  // Finally, set the Y of the actual legend item element.
  for (let i = 0; i < itemY.length; i++) {
    if (itemY[i].y < botY) {
      transform.write(items[itemY[i].index], 'translate', null, itemY[i].y);
    } else {
      element.removeChild(items[itemY[i].index]);
    }
  }
}


// Returns array of Y positions for each legend item for column charts.
function getColumnItemsY(container, items, options) {
  const fontSize = parseFloat(options.styles.size.normal);
  const seriesEl = container.querySelector('.highcharts-series-group');
  const barsEl = seriesEl.querySelectorAll('.highcharts-series');
  const printOffset = options.print ? -8 : 0;
  let itemY = [];

  for (let i = 0; i < items.length; i++) {
    // Get the path's parent and path Y.
    const g = barsEl[i];
    const rects = g.querySelectorAll('rect');
    const r = rects[rects.length - 1];
    const rY = (rects && rects.length) ?
      (transform.read(g, 'translate')[1] +
        (+r.getAttribute('y') + +r.getAttribute('height') / 2)) :
      fontSize;

    // Combine the results.
    itemY[i] = {
      index: i,
      y: rY - fontSize + printOffset
    };
  }

  return sortItemY(itemY);
}

// Returns array of Y positions for each legend item for line/area charts.
function getLineItemsY(container, items, options) {
  const fontSize = parseFloat(options.styles.size.normal);
  const seriesEl = container.querySelector('.highcharts-series-group');
  const linesEl = seriesEl.querySelectorAll('.highcharts-series');
  const itemY = [];

  for (let i = 0; i < items.length; i++) {
    // Get the path's parent and path Y.
    // var pathEl = seriesEl.querySelector('.highcharts-series.highcharts-series-' + i);
    const lineIndex = (options.type === 'area') ? i :
      (items.length - i - 1);
    const pathEl = linesEl[lineIndex];
    const pathElY = transform.read(pathEl, 'translate')[1];
    const paths = pathEl.querySelectorAll('path');
    const d = transform.read(paths[0], 'd');
    d.sort((a, b) => {
      return b[0] - a[0];
    });

    let pathY;
    if (options.type === 'line') {
      pathY = d[0][1];
    } else {
      const dx = d[0][0];
      const d0 = d.filter(item => {
        return item[0] === dx;
      }).sort((a, b) => {
        return a[1] - b[1]
      });
      if (d0.length >= 2) {
        pathY = (d0[d0.length - 1][1] - d0[0][1]) / 2 + d0[0][1];
      } else {
        pathY = d0[0][1];
      }
    }

    // Combine the results.
    itemY[i] = {
      index: i,
      y: pathY + fontSize / 2
    };
  }

  return sortItemY(itemY);
}


// Sort on Y and return.
function sortItemY(itemY) {
  itemY.sort((a, b) => {
    return a.y - b.y;
  });
  return itemY;
}



// WEBPACK FOOTER //
// ./src/chart/inner/legend.js